@app.directive 'matrixItemCard', (matrixItemService, mobileDetectionService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @isRecipe = matrixItemService.isRecipe
    @isMobile = mobileDetectionService.isMobile
    this
  controllerAs: 'matrixItemCard'
  templateUrl: "/assets/templates/components/matrix/matrixItem/matrixItemCard/matrixItemCard.html"
  bindToController: {
    content: '='
    descriptionCharLimit: '='
    showLikes: '='
    loadImageOnEnterViewport: '='
    track: '&'
  }
